export const ResetButton = () => {
  return (
    <button className="big-button" onClick={() => window.location.reload()}>
      🔄
    </button>
  );
};
